//
import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./pages/home/home.component').then(
                (mod) => mod.HomeComponent
            ),
    },
    {
        path: 'about-us',
        loadComponent: () =>
            import('./pages/about-us/about-us.component').then(
                (mod) => mod.AboutUsComponent
            ),
    },
    {
        path: 'solutions',
        loadComponent: () =>
            import('./pages/solutions/solutions.component').then(
                (mod) => mod.SolutionsComponent
            ),
    },
    {
        path: 'insights',
        loadComponent: () =>
            import('./pages/insights/insights.component').then(
                (mod) => mod.InsightsComponent
            ),
    },
    {
        path: 'media-corner',
        loadComponent: () =>
            import('./pages/media-corner/media-corner.component').then(
                (mod) => mod.MediaCornerComponent
            ),
    },
    {
        path: 'media-corner-detail',
        loadComponent: () =>
            import('./pages/media-corner-detail/media-corner-detail.component').then(
                (mod) => mod.MediaCornerDetailComponent
            ),
    },
    {
        path: 'contact-us',
        loadComponent: () =>
            import('./pages/contact-us/contact-us.component').then(
                (mod) => mod.ContactUsComponent
            ),
    },
    {
        path: 'blog/investing-for-women-grow-your-capital',
        loadComponent: () =>
            import('./pages/blog-detail/blog-detail.component').then(
                (mod) => mod.BlogDetailComponent
            ),
    },
    {
        path: 'blog/arbitrage-funds-vs-liquid-funds-for-hnis',
        loadComponent: () =>
            import('./pages/blog-arbitrage-funds/blog-arbitrage-funds.component').then(
                (mod) => mod.BlogDetailComponent
            ),
    },
    {
        path: 'blog/proactive-estate-planning-india',
        loadComponent: () =>
            import('./pages/blog-estate/blog-estate.component').then(
                (mod) => mod.BlogEstateComponent

            ),
    },
    {
        path: 'blog/family-finance-playbook-safeguard-wealth',
        loadComponent: () =>
            import('./pages/blog-family/blog-family.component').then(
                (mod) => mod.BlogFamilyComponent

            ),
    },
    {
        path: 'blog/why-investors-add-corporate-bonds-portfolio',
        loadComponent: () =>
            import('./pages/blog-investor/blog-investor.component').then(
                (mod) => mod.BlogInvestorComponent

            ),
    },
    {
        path: 'blog/retirement-planning-with-clarity',
        loadComponent: () =>
            import('./pages/blog-retirement/blog-retirement.component').then(
                (mod) => mod.BlogRetirementComponent
            ),
    },
    {
        path: 'blog/tax-planning-for-long-term-wealth',
        loadComponent: () =>
            import('./pages/blog-tax/blog-tax.component').then(
                (mod) => mod.BlogTaxComponent
            ),
    },
    {
        path: 'blog/wealth-preservation-in-volatile-market',
        loadComponent: () =>
            import('./pages/wealth-preservation/wealth-preservation.component').then(
                (mod) => mod.WealthPreservationComponent
            ),
    },
    {
        path: 'blog/build-wealth-with-life-and-health-insurance',
        loadComponent: () =>
            import('./pages/health-foundation/health-foundation.component').then(
                (mod) => mod.HealthFoundationComponent
            ),
    },
    {
        path: 'blog/ai-in-wealth-management',
        loadComponent: () =>
            import('./pages/ai-finance/ai-finance.component').then(
                (mod) => mod.AiFinanceComponent
            ),
    },
    {
        path: 'blog/what-is-wealth-management',
        loadComponent: () =>
            import('./pages/what-is-wealth-management/what-is-wealth-management.component').then(
                (mod) => mod.WhatIsWealthManagementComponent
            ),
    },
    {
        path: 'blog/wealth-tax-in-india',
        loadComponent: () =>
            import('./pages/what-is-wealth-tax/what-is-wealth-tax.component').then(
                (mod) => mod.WhatIsWealthTaxComponent
            ),
    },
    {
        path: 'blog/wealth-managers-philanthropic-goals-impact-strategy',
        loadComponent: () =>
            import('./pages/philanthropic-skills/philanthropic-skills.component').then(
                (mod) => mod.PhilanthropicSkillsComponent
            ),
    },
    {
        path: 'blog/gold-silver-price-fluctuations-portfolio-impact',
        loadComponent: () =>
            import('./pages/gold-silver/gold-silver.component').then(
                (mod) => mod.GoldSilverComponent
            ),
    },
    {
        path: 'blog/mastering-asset-allocation',
        loadComponent: () =>
            import('./pages/asset-allocation/asset-allocation.component').then(
                (mod) => mod.AssetAllocationComponent
            ),
    },
    {
        path: 'blog/how-research-driven-screening-builds-wealth',
        loadComponent: () =>
            import('./pages/instituition-alised/instituition-alised.component').then(
                (mod) => mod.InstituitionAlisedComponent
            ),
    },
    {
        path: 'blog/herd-mentality-overpriced-investments',
        loadComponent: () =>
            import('./pages/herd-mentality/herd-mentality.component').then(
                (mod) => mod.HerdMentalityComponent
            ),
    },
    {
        path: 'blog/egos-vs-algos-human-led-ai-wealth-management',
        loadComponent: () =>
            import('./pages/egos-algos/egos-algos.component').then(
                (mod) => mod.EgosAlgosComponent
            ),
    },
    {
        path: 'blog/building-a-well-oiled-portfolio',
        loadComponent: () =>
            import('./pages/oil-portfolio/oil-portfolio.component').then(
                (mod) => mod.OilPortfolioComponent
            ),
    },
    // {
    //     path: 'blog/the-1980s-back-to-the-past',
    //     loadComponent: () =>
    //         import('./pages/back-to-the-past/back-to-the-past.component').then(
    //             (mod) => mod.BackToThePastComponent
    //         ),
    // },
    {
        path: 'blog/eating-soup-with-chopsticks-how-not-to-build-a-portfolio',
        loadComponent: () =>
            import('./pages/eating-soup-with-chopsticks/eating-soup-with-chopsticks.component').then(
                (mod) => mod.EatingSoupWithChopsticksComponent
            ),
    },
    {
        path: 'global',
        loadComponent: () =>
            import('./pages/global/global.component').then(
                (mod) => mod.GlobalComponent
            ),
    },
    {
        path: 'blog',
        loadComponent: () =>
            import('./pages/blog/blog.component').then(
                (mod) => mod.BlogComponent
            ),
    },
    {
        path: 'career',
        loadComponent: () =>
            import('./pages/career-listing/career-listing.component').then(
                (mod) => mod.CareerListingComponent
            ),
    },
    {
        path: 'sitemap',
        loadComponent: () =>
            import('./pages/sitemap/sitemap.component').then(
                (mod) => mod.SitemapComponent
            ),
    },
    {
        path: 'career/:slug',
        loadComponent: () =>
            import('./pages/career-detail/career-detail.component').then(
                (mod) => mod.CareerDetailComponent
            ),
    },
    {
        path: '**',
        loadComponent: () =>
            import('./pages/page-not-found/page-not-found.component').then(
                (mod) => mod.PageNotFoundComponent
            ),
        // data: { error_code: 404 },
    },
    {
        path: 'not-found',
        loadComponent: () =>
            import('./pages/page-not-found/page-not-found.component').then(
                (mod) => mod.PageNotFoundComponent
            ),
        // data: { error_code: 404 },
    },
];
